import {Quote} from "../../api/models";
import React, {CSSProperties, useRef, useState} from "react";
import {InputStatus} from "antd/es/_util/statusUtils";
import {Button, InputNumber, Popover} from "antd";
import Configurator from "../../pages/configurator";

const QuoteQuantityInput = (props:{
    quote:Quote | undefined
    readOnly?: boolean
    onChange?: (q: number) => void
    txtStyle?: CSSProperties
    btnStyle?: CSSProperties
}) => {

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const inputRef = useRef<HTMLInputElement>(null);
    const txtStyle = {
        borderBottom: "1px solid black",
        ...props.txtStyle,
    };
    const [quantity, setQuantity] = useState<number>();
    const [inputStatus, setInputStatus] = useState<InputStatus>();

    const handleOpen = () => {
        setInputStatus(undefined);
        setQuantity(props.quote?.quantity);
        setIsOpen(true);
    }
    const handleBlur = () => {

        if ( quantity === undefined || quantity === null || quantity < 1 ) {
            setInputStatus('error');
            return;
        }

        setIsOpen(false);

        props.onChange?.( quantity );
    }

    const truckLbl = ( props.quote?.quantity || 0 ) > 1 ? "units" : "unit";
    const btnTitle = props.quote?.quantity != undefined ? [ props.quote?.quantity, truckLbl].join(' ') : "None";

    return <Popover
        trigger={"click"}
        afterOpenChange={(open) => {
            if( open ) {
                inputRef.current?.focus();
            }
        }}
        open={isOpen}
        content={<InputNumber
            ref={inputRef}
            value={quantity}
            onChange={(value) => setQuantity( value || undefined )}
            onBlur={handleBlur}
            onPressEnter={() => inputRef.current?.blur()}
            status={inputStatus}
        /> }
        arrow={false}
    >
        {props.readOnly ? btnTitle
            : <Button className="ghostBmButton" type="text" onClick={handleOpen}
                          title={btnTitle}
                          style={{
                              ...props.btnStyle,
                              margin: 0,
                              padding: 0
                          }} >
                    <span style={txtStyle}>{btnTitle}</span>
                </Button>}
    </Popover>;
}


export default QuoteQuantityInput;
